import React, { Component } from 'react';
import styled from 'styled-components';

export default class LabelledTextInput extends Component {
  constructor(props) {
    super(props);

    this.focus = this.focus.bind(this);
  }

  focus() {
    this.refs.input.focus();
  }

  render() {
    const display = !!this.props.value ? 'block' : 'none';
    const marginTop = !!this.props.value ? '20px' : '10px';
    const width = !!this.props.width ? this.props.width : '100%';

    return (
      <Container onClick={() => this.focus()} error={this.props.error}>
        <label htmlFor={this.props.name} style={{ display }}>{this.props.placeHolder}</label>
        <div>
          <input
            ref="input"
            type={this.props.type}
            name={this.props.name}
            value={this.props.value}
            placeholder={this.props.placeHolder}
            style={Object.assign(this.props.style || {}, { width, marginTop, position: 'relative' })}
            onChange={this.props.onChange}
          />
        </div>
      </Container>
    );
  }
}

const Container = styled.div`
  height: 45px;
  border: 2px solid ${props => props.error ? '#ff5c6c' : '#e5e5e5'};
  border-radius: 0.25em;
  padding: 0.7em 1em;

  input {
    font-size: 20px;
    position: absolute;
    background: transparent;
    border: 0px;
    padding: 0px;
    font-family: 'Karla', sans-serif;
    z-index: 1;

    &::placeholder {
      opacity: 1;
      color: #a1aeb7;
    }
    &:focus {
      outline: none;
    }
  }

  label {
    z-index: -5;
    position: absolute;
    color: #a1aeb7 !important;
    font-size: 15px;
    margin-top: 2px;
    font-family: 'Karla', sans-serif;
  }
`;



// WEBPACK FOOTER //
// ./client/redesign/web/components/LabelledTextInput/index.js